import { createRouter, createWebHistory } from 'vue-router';
import CartPage from './pages/CartPage.vue';
import HomePage from './pages/Home/HomePage.vue';
import PageNotFound from './pages/PageNotFound.vue';
import PaymentFailPage from './pages/PaymentFailPage.vue';

import ContactUs from './pages/ContactUs.vue';
import PaymentSuccessPage from './pages/PaymentSuccessPage.vue';
import ProductListPage from './pages/ProductListPage.vue';
import ProfilePage from './pages/ProfilePage.vue';
import TextPage from './pages/TextPage.vue';

const routes = [
	{
		path: '/',
		name: 'HomePage',
		component: HomePage,
	},
	//{
	//	path: '/signin',
	//	name: 'SigninPage',
	//	component: SigninPage,
	//},
	//{
	//	path: '/singup',
	//	name: 'SignupPage',
	//	component: SignupPage,
	//},
	{
		path: '/products/:itemType?',
		name: 'ProductListPage',
		component: ProductListPage,
		props: true,
	},
	//{
	//	path: '/product/:id',
	//	name: 'ProductPage',
	//	component: ProductPage,
	//	props: true,
	//},
	{
		path: '/profile/:page?',
		name: 'ProfilePage',
		component: ProfilePage,
	},
	{
		path: '/checkout',
		name: 'CartPage',
		component: CartPage,
	},
	{
		path: '/contact-us',
		name: 'ContactUs',
		component: ContactUs,
	},
	{
		path: '/:slug',
		name: 'TextPage',
		component: TextPage,
		props: true,
	},
	{
		path: '/success-payment',
		name: 'PaymentSuccessPage',
		component: PaymentSuccessPage,
	},
	{
		path: '/fail-payment',
		name: 'PaymentFailPage',
		component: PaymentFailPage,
	},
	//{
	//	path: '/sell-skin',
	//	name: 'SellSkin',
	//	component: SellSkin,
	//},
	{
		path: '/:pathMatch(.*)*',
		name: 'PageNotFound',
		component: PageNotFound,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
